import React from 'react';
import ReactDOM from 'react-dom/client';

// CSS load order is load-bearing — see `src/index.css` for the contract.
//   1. index.css           → Tailwind layers + global resets + component classes.
//                            Internally @imports themes.css then colors.css so
//                            CSS variables are defined before any @apply runs.
//   2. (themes.css / colors.css are imported via index.css)
import './index.css';

import 'i18n/i18n';
import App from './App';
import { getMetaDataDetails } from 'stores/metadata-store';
import { getWorkFlowDetails } from 'stores/workflow-store';
import { cleanupOrphanCaches } from 'utils/cleanupOrphanCaches';
import { initClarity } from 'utils/initClarity';

cleanupOrphanCaches();

// Vue parity: `RW-ERP-Service/src/main.ts` initializes Clarity at app boot,
// before the router/app renders. See `utils/initClarity.ts`.
initClarity();

// Eagerly preload the workflow + metadata blobs so they're already in the
// in-memory store by the time any feature mounts. Both calls share their
// inflight promise, so a feature that hooks `useAttributeMetadata` /
// `useWorkflow` mid-flight will join the same request rather than firing
// duplicates.
void getWorkFlowDetails();
void getMetaDataDetails();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
